import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Image,
  Badge,
  Skeleton,
  SimpleGrid,
  Icon,
} from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FiChevronLeft, FiChevronRight, FiArrowRight } from "react-icons/fi";
import { Link, NavLink } from "react-router-dom";
import { apiUrl, fetchSharedBooks } from "../../ApiUrl/ApiUrl";

function TopOffers() {
  const [taxLaw, setTaxLaw] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const PrevArrow = ({ onClick }) => (
    <Box
      position="absolute"
      left="-12px"
      top="45%"
      transform="translateY(-50%)"
      zIndex="2"
      w="38px"
      h="38px"
      bg="white"
      border="1px solid #E2E8F0"
      color="gray.800"
      rounded="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      transition="all 0.2s"
      _hover={{ bg: "#0F172A", color: "white", transform: "translateY(-50%) scale(1.08)" }}
      shadow="md"
      onClick={onClick}
    >
      <Icon as={FiChevronLeft} boxSize="20px" />
    </Box>
  );

  const NextArrow = ({ onClick }) => (
    <Box
      position="absolute"
      right="-12px"
      top="45%"
      transform="translateY(-50%)"
      zIndex="2"
      w="38px"
      h="38px"
      bg="white"
      border="1px solid #E2E8F0"
      color="gray.800"
      rounded="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      transition="all 0.2s"
      _hover={{ bg: "#0F172A", color: "white", transform: "translateY(-50%) scale(1.08)" }}
      shadow="md"
      onClick={onClick}
    >
      <Icon as={FiChevronRight} boxSize="20px" />
    </Box>
  );

  const settings = {
    infinite: true,
    speed: 400,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 640, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
    ],
  };

  useEffect(() => {
    setLoading(true);
    fetchSharedBooks()
      .then((data) => setTaxLaw(data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  const items = taxLaw.filter((item) => item.subcatname === "Tax Law");

  if (loading) {
    return (
      <Box maxW="1360px" mx="auto" px={{ base: "4", md: "8" }} py="6">
        <Skeleton height="30px" width="220px" mb="4" rounded="md" />
        <SimpleGrid columns={{ base: 2, md: 5 }} spacing="4">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} height="280px" rounded="xl" />
          ))}
        </SimpleGrid>
      </Box>
    );
  }

  if (error || items.length === 0) return null;

  return (
    <Box maxW="1360px" mx="auto" px={{ base: "3", md: "6", lg: "8" }} py="5">
      <Flex justify="space-between" align="center" mb="4">
        <Box>
          <Text fontSize={{ base: "18px", md: "22px" }} fontWeight="800" color="gray.900" letterSpacing="-0.3px">
            Taxation, GST & Corporate Law
          </Text>
          <Text fontSize="12.5px" color="gray.500">
            Direct taxes, GST act, customs, and company law manuals
          </Text>
        </Box>
        <Link
          to="/products?maincat=Books"
          onClick={() => localStorage.setItem("subcatname", "Tax Law")}
        >
          <Flex
            align="center"
            gap="1.5"
            fontSize="13px"
            fontWeight="bold"
            color="#2563EB"
            _hover={{ color: "#1D4ED8", textDecoration: "underline" }}
            cursor="pointer"
          >
            <span>View All</span>
            <Icon as={FiArrowRight} boxSize="14px" />
          </Flex>
        </Link>
      </Flex>

      <Box position="relative" px={{ base: "1", md: "2" }}>
        <Slider {...settings}>
          {items.map((item, index) => {
            const discountPct = Math.round(((item.originalprice - item.descprice) / item.originalprice) * 100);
            return (
              <Box key={item.id || index} px="2" py="2">
                <NavLink to={`/products/view/${item.id}`}>
                  <Box
                    bg="white"
                    border="1px solid #E2E8F0"
                    rounded="xl"
                    overflow="hidden"
                    p="3"
                    shadow="sm"
                    transition="all 0.25s ease"
                    _hover={{
                      transform: "translateY(-4px)",
                      shadow: "0 12px 24px -4px rgba(15, 23, 42, 0.1)",
                      borderColor: "blue.400",
                    }}
                    h="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                  >
                    <Box
                      h={{ base: "160px", md: "190px" }}
                      bg="#F8FAFC"
                      rounded="lg"
                      p="2"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      overflow="hidden"
                      mb="3"
                    >
                      <Image
                        src={item.imagePath}
                        alt={item.booktitle}
                        maxH="100%"
                        maxW="100%"
                        objectFit="contain"
                        transition="transform 0.3s ease"
                        _hover={{ transform: "scale(1.05)" }}
                        fallbackSrc="https://navneetlawstudio.com/logo.png"
                      />
                    </Box>

                    <Box>
                      <Text
                        fontSize={{ base: "13px", md: "14px" }}
                        fontWeight="600"
                        color="gray.900"
                        lineHeight="1.3"
                        noOfLines={2}
                        mb="2"
                      >
                        {item.booktitle}
                      </Text>

                      <Flex align="baseline" gap="2" wrap="wrap">
                        <Text fontSize={{ base: "15px", md: "17px" }} fontWeight="800" color="gray.900">
                          ₹{item.descprice}
                        </Text>
                        {item.originalprice > item.descprice && (
                          <Text fontSize="12px" color="gray.400" as="del">
                            ₹{item.originalprice}
                          </Text>
                        )}
                        {discountPct > 0 && (
                          <Badge colorScheme="green" fontSize="10.5px" px="1.5" py="0.2" rounded="md">
                            {discountPct}% OFF
                          </Badge>
                        )}
                      </Flex>
                    </Box>
                  </Box>
                </NavLink>
              </Box>
            );
          })}
        </Slider>
      </Box>
    </Box>
  );
}

export default TopOffers;